import { Tag } from 'antd';

/**
 * 视频音画交互场景类型（与后端 VideoSceneType 对应）
 */
const sceneTypeLabels: Readonly<Record<string, string>> = {
  narration: '旁白/解说',
  monologue: '口播/单人出镜',
  dialogue_single: '单人说话/非对谈',
  dialogue_multi: '多人对话',
};

export function VideoTranslationSceneTypeTag(props: {
  sceneType: string | undefined;
  needs_translation: boolean | undefined;
}) {
  if (props.needs_translation === false) {
    return <Tag>无字幕、无人声</Tag>;
  }

  if (!props.sceneType) {
    return null;
  }

  const label = sceneTypeLabels[props.sceneType] ?? props.sceneType;

  return <Tag>场景：{label}</Tag>;
}
